import React from 'react'
import { Link } from 'gatsby'

const NavigationTwoSlidesLeft = ({ toggleNavOpen }) => (
  // console.log('left')

  <div>
    {/* <h1>Left</h1> */}
    <div className="container-left-checkout-menu">
      <div className="left-menu-item left-item-1">
        <Link to="/" className="w3-btn w3-black" onClick={toggleNavOpen}>
          Home
        </Link>
      </div>
      <div className="left-menu-item left-item-1">
        <Link
          to="/powder-brows/"
          className="w3-btn w3-black"
          onClick={toggleNavOpen}
        >
          Powder Brows
        </Link>
      </div>
      <div className="left-menu-item left-item-2">
        <Link
          to="/lip-blush/"
          className="w3-btn w3-black"
          onClick={toggleNavOpen}
        >
          Lip Blush
        </Link>
      </div>
      <div className="left-menu-item left-item-3">
        <Link
          to="/ombre-brows/"
          className="w3-btn w3-black"
          onClick={toggleNavOpen}
        >
          Ombre Brows
        </Link>
      </div>
      <div className="left-menu-item left-item-4">
        <Link
          to="/microshading-brows/"
          className="w3-btn w3-black"
          onClick={toggleNavOpen}
        >
          Microshading Brows
        </Link>
      </div>
      <div className="left-menu-item left-item-5">
        <Link
          to="/lash-line-enhancement/"
          className="w3-btn w3-black"
          onClick={toggleNavOpen}
        >
          Lash Line Enhancement
        </Link>
      </div>
      <div className="left-menu-item left-item-6">
        <Link
          to="/permanent-makeup-process/"
          className="w3-btn w3-black"
          onClick={toggleNavOpen}
        >
          The Process
        </Link>
      </div>
      <div className="left-menu-item left-item-7">
        <Link
          to="/portfolio/"
          className="w3-btn w3-black"
          onClick={toggleNavOpen}
        >
          Portfolio
        </Link>
      </div>
      <div className="left-menu-item left-item-9">
        <Link to="/li-ft-removal/" className="w3-btn w3-black" onClick={toggleNavOpen}>
          Li-FT Removal
        </Link>
      </div>
      <div style={{opacity: 1}} className="left-menu-item left-item-9">
        <a
          className="w3-btn w3-black"
          rel="noopener noreferrer nofollow"
          target="_blank"
          href={"https://square.site/book/3Q13NMMB2RG0E/longmakeup-permanent-makeup-nyc-new-york-ny"}>
          Online Booking
        </a>
      </div>
      <div style={{opacity: 1}} className="left-menu-item left-item-10">
        <Link
          to="/contact/"
          className="w3-btn w3-black"
          onClick={toggleNavOpen}
        >
          Contact
        </Link>
      </div>
      <div className="left-menu-item left-item-8">
        <Link to="/faq/" className="w3-btn w3-black" onClick={toggleNavOpen}>
          FAQ
        </Link>
      </div>
      <div className="left-menu-item left-item-9">
        <Link to="/pricing/" className="w3-btn w3-black" onClick={toggleNavOpen}>
          Pricing
        </Link>
      </div>
      <div className="left-menu-item left-item-9">
        <Link to="/blog/" className="w3-btn w3-black" onClick={toggleNavOpen}>
          Blog
        </Link>
      </div>
    </div>
  </div>
)

export default NavigationTwoSlidesLeft
